import { kanban } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getKanban(project) {
      const state = getState().find(
        ({ project: { uuid } }) => uuid === project.uuid,
      );

      return state ? state.kanban : kanban;
    },
    isRetrieveKanbanRequestFailure(project) {
      const state = getState().find(
        ({ project: { uuid } }) => uuid === project.uuid,
      );

      return state ? state.request.isFailure : false;
    },
    isRetrieveKanbanRequestPending(project) {
      const state = getState().find(
        ({ project: { uuid } }) => uuid === project.uuid,
      );

      return state ? state.request.isPending : false;
    },
    isRetrieveKanbanRequestSuccess(project) {
      const state = getState().find(
        ({ project: { uuid } }) => uuid === project.uuid,
      );

      return state ? state.request.isSuccessful : false;
    },
  };
}

export { createSelector };
